var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"demo-page"},[(_vm.ready)?_c('ResultsPage'):_vm._e(),_c('DemoDialog',{attrs:{"dialog":_vm.showDemoDialog},on:{"close":function($event){return _vm.closeDemoDialog()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }